import { NavMenuItem } from '@core/types';
import { ROLE } from '../../auth/enums/roles.enum';
import { PERMISSIONS } from '../../auth/enums/permissions.enum';
import { EmailFolder } from '@core/enums';

/**
 * Navigation menu items for WEB Sidebar
 */
export const webSidebarMenuItems: NavMenuItem[] = [
  {
    href: '/dashboard',
    icon: 'home-fill',
    title: 'Home',
    active: true,
    subItems: [],
  },
  {
    href: '/club-overview/news',
    icon: 'widget-fill',
    title: 'Club Overview',
    active: false,
    disabled: false,
    subItems: [],
  },
  {
    href: '/discover/news',
    icon: 'document-fill',
    title: 'nav.news',
    active: false,
    subItems: [],
  },
  {
    href: '/events',
    icon: 'calendar-fill',
    title: 'Events',
    active: false,
    disabled: false,
    subItems: [],
  },
  {
    href: '/groups',
    icon: 'user-pair-fill',
    title: 'nav.groups',
    active: false,
    subItems: [],
  },
  {
    href: '/messages',
    icon: 'chat-message-fill',
    title: 'nav.messages',
    active: false,
    subItems: [],
  },
  {
    href: '/tasks',
    icon: 'checklist-fill',
    title: 'nav.tasks',
    active: false,
    subItems: [],
  },
  {
    href: '/courses',
    icon: 'graduation-cap-fill',
    title: 'nav.courses',
    active: false,
    permissions: [PERMISSIONS.VCLOUD_COURSE],
  },
  {
    href: '/club-tools',
    icon: 'pie-chart-fill',
    title: 'nav.club tools',
    active: false,
    disabled: false,
    subItems: [
      { href: '/club-tools/surveys', icon: 'round-graph', title: 'nav.survey' },
      { href: '/club-tools/faq', icon: 'dual-chat-fill', title: 'nav.faq' },
      { href: '/club-tools/members', icon: 'user-pair-fill', title: 'Members', roles: [ROLE.ADMIN] },
      // { href: '/club-tools/work-shifts', icon: 'clock-fill', title: 'Work Shifts', permissions: [PERMISSIONS.VCLOUD_WORK_SHIFTS] },
      { href: '/club-tools/documents', icon: 'document', title: 'nav.documents' },
    ],
  },

  {
    href: '/club/add-ons',
    icon: 'layers-fill',
    title: 'nav.club addons',
    active: false,
    permissions: [PERMISSIONS.CREATE_EMAIL],
    subItems: [], // Subitems for this menu item will be added through web sidebar component as the links are dynamic
  },
  {
    href: '/more',
    icon: 'ellipsis-horizontal',
    title: 'nav.more',
    active: false,
    permissions: [PERMISSIONS.CREATE_BANNER, PERMISSIONS.CREATE_EMAIL, PERMISSIONS.CREATE_TAGS, PERMISSIONS.PARTICIPATE_ALL_LIST],
    subItems: [
      { href: 'more/banners', icon: 'gallery', title: 'Banners', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: 'more/banners/stats', icon: 'round-graph', title: 'Banner Statistics', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: 'more/emails', icon: 'calendar-mini', title: 'nav.emails', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: 'more/tags', icon: 'question-circle', title: 'nav.tags', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: 'more/my-content', icon: 'magic-stick', title: 'nav.my content', permissions: [PERMISSIONS.PARTICIPATE_ALL_LIST] },
    ],
  },
  {
    href: '/impressum',
    icon: 'book-fill',
    title: 'Impressum',
    active: false,
  },
  {
    href: 'add',
    icon: 'add-circle-fill',
    title: 'nav.add',
    active: true,
    roles: [ROLE.ADMIN, ROLE.FUNCTIONARY],
  },
  {
    divider: true,
    active: false,
    href: null,
    title: 'Divider',
    icon: null,
  },
  {
    href: '/user',
    icon: 'user-id',
    title: 'nav.my profile',
    active: false,
    disabled: false,
  },
  // {
  //   href: '/settings',
  //   icon: 'settings-fill',
  //   title: 'nav.settings',
  //   active: false,
  //   disabled: true,
  // },
];

/**
 * Navigation menu items for MOBILE Sidebar
 */
export const mobileSidebarMenuItems: NavMenuItem[] = [
  {
    href: '/m/dashboard',
    icon: 'home',
    title: 'Home',
    active: false,
    subItems: [],
  },
  {
    href: '/m/club-wall/events',
    icon: 'widget',
    title: 'Club Overview',
    active: false,
    disabled: false,
    subItems: [],
  },
  {
    href: '/m/news',
    icon: 'document',
    title: 'nav.news',
    active: false,
    subItems: [],
  },
  {
    href: '/m/events',
    icon: 'calendar',
    title: 'Events',
    active: false,
    disabled: false,
    subItems: [],
  },
  {
    href: '/m/groups',
    icon: 'user-pair',
    title: 'nav.groups',
    active: false,
    subItems: [],
  },
  {
    href: '/m/messages',
    icon: 'chat-round-check',
    title: 'nav.messages',
    active: false,
  },
  {
    href: '/m/tasks',
    icon: 'checklist',
    title: 'nav.tasks',
    active: false,
  },
  {
    href: '/m/courses',
    icon: 'graduation-cap',
    title: 'nav.courses',
    active: false,
    permissions: [PERMISSIONS.VCLOUD_COURSE],
  },
  {
    href: '/m/club-tools',
    icon: 'pie-chart',
    title: 'nav.club tools',
    active: false,
    subItems: [
      { href: '/m/club-tools/surveys', icon: 'round-graph', title: 'nav.survey' },
      { href: '/m/club-tools/faq', icon: 'dual-chat-fill', title: 'nav.faq' },
      { href: '/m/club-tools/members', icon: 'user-pair', title: 'Members', roles: [ROLE.ADMIN] },
      // { href: '/m/club-tools/work-shifts', icon: 'clock-fill', title: 'Work Shifts', permissions: [PERMISSIONS.VCLOUD_WORK_SHIFTS] },
      { href: '/m/club-tools/documents', icon: 'document', title: 'Documents' },
    ],
  },

  // {
  //   href: '/m/club/add-ons',
  //   icon: 'layers-fill',
  //   title: 'nav.club addons',
  //   active: false,
  //   permissions: [PERMISSIONS.CREATE_EMAIL],
  //   subItems: [], // Subitems for this menu item will be added through mobile sidebar component as the links are dynamic
  // },
  {
    href: null,
    icon: 'v-ellipsis',
    title: 'nav.more',
    active: false,
    roles: [ROLE.ADMIN, ROLE.FUNCTIONARY],
    subItems: [
      { href: '/m/more/banners', icon: 'round-graph', title: 'Banners', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: '/m/more/emails', icon: 'calendar-mini', title: 'nav.emails', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
      { href: '/m/more/tags', icon: 'question-circle', title: 'nav.tags', roles: [ROLE.ADMIN, ROLE.FUNCTIONARY] },
    ],
  },
  // {
  //   href: '/m/add',
  //   icon: 'add-circle',
  //   title: 'nav.add',
  //   disabled: true,
  //   active: false,
  // },
  {
    href: '/m/notifications',
    icon: 'notification',
    title: 'Notifications',
    active: false,
  },
  {
    href: '/m/impressum',
    icon: 'book',
    title: 'Impressum',
    active: false,
  },
  {
    href: '/m/profile',
    icon: 'user',
    title: 'nav.my profile',
    active: false,
  },
  {
    href: '/m/profile/settings',
    icon: 'settings-fill',
    title: 'nav.settings',
    active: false,
  },
  // {
  //   href: '/m/app-store',
  //   icon: 'app-store',
  //   title: 'nav.app store',
  //   active: false,
  //   subItems: [
  //     { url: 'https://play.google.com/store/apps/details?id=com.verein.cloud', icon: 'playstore', title: 'Android App' },
  //     { url: 'https://apps.apple.com/au/app/verein-cloud/id6447562632', icon: 'apple', title: 'iOS App' },
  //   ],
  // },
  // Add more sidebar items as needed
];

/**
 * Navigation menu items for MOBILE Bottom Navigation
 */
export const bottomNavigationMenuItems: NavMenuItem[] = [
  {
    href: '/m/dashboard',
    icon: 'home',
    title: 'Home',
    active: true,
  },
  {
    href: '/m/news',
    icon: 'document',
    title: 'nav.news',
    active: false,
  },
  {
    href: '/m/create',
    icon: 'add-circle',
    title: 'community.create',
    active: false,
  },
  {
    href: '/m/profile',
    icon: 'user',
    title: 'nav.my profile',
    active: false,
  },
  // {
  //   href: '/settings',
  //   icon: 'Chat',
  //   title: 'nav.settings',
  //   active: false,
  // },
  {
    href: '/m/messages',
    icon: 'chat',
    title: 'nav.chat',
    active: false,
  },
];

/**
 * Navigation menu items for WEB & Mobile Create PopUp Dialog/Bottom Sheet
 * @property {string} href - URL to navigate to for WEB
 * @property {string} url - URL to navigate to for MOBILE
 */
export const createElementNavigationMenuItems: NavMenuItem[] = [
  {
    href: '/messages/email',
    url: '/m/messages/email',
    icon: 'envelope-fill',
    title: 'Message ',
    permissions: [PERMISSIONS.CREATE_MESSAGE],
  },
  {
    href: '/messages',
    url: '/m/messages',
    icon: 'chat-message-fill',
    title: 'Chat',
    permissions: [PERMISSIONS.CREATE_CHAT],
  },
  {
    href: '/discover/news',
    url: '/m/club-wall/news',
    icon: 'pencil-fill-line',
    title: 'News',
    permissions: [PERMISSIONS.CREATE_NEWS],
  },
  {
    href: '/club-overview/events',
    url: '/m/club-wall/events',
    icon: 'calendar-fill',
    title: 'Event',
    permissions: [PERMISSIONS.CREATE_EVENT],
  },
  {
    href: '/tasks',
    url: '/m/tasks',
    icon: 'checklist-fill',
    title: 'Task',
    permissions: [PERMISSIONS.CREATE_TASK],
  },
  {
    href: '/groups',
    url: '/m/groups',
    icon: 'user-pair-fill',
    title: 'Group',
    permissions: [PERMISSIONS.CREATE_GROUP],
  },
  {
    href: '/more/emails/create',
    url: '/m/more/emails/create',
    icon: 'envelope-fill',
    title: 'Email Template',
    permissions: [PERMISSIONS.CREATE_EMAIL],
  },
  {
    href: '/more/banners/create',
    url: '/m/more/banners/create',
    icon: 'round-graph',
    title: 'Banner',
    permissions: [PERMISSIONS.CREATE_BANNER],
  },
];

/**
 * Navigation menu items for User Profile
 */
export const userNavigationMenuItems: NavMenuItem[] = [
  {
    href: '/user-profile',
    icon: 'user',
    title: 'users.general information',
    active: true,
  },
  {
    href: '/password',
    icon: 'lock',
    title: 'loginForm.Password',
    active: false,
  },
  {
    href: '/wallet',
    icon: 'wallet',
    title: 'users.my payment data',
    active: false,
  },
  {
    href: '/data',
    icon: 'document',
    title: 'users.association master data',
    active: false,
  },
  {
    href: '/club',
    icon: 'user',
    title: 'users.me at the club',
    active: false,
  },
];

/**
 * Email Messages Folders Navigation Menu Items
 */

export const emailMessagesFolders: NavMenuItem[] = [
  {
    icon: 'envelope-notification',
    title: EmailFolder.INBOX,
  },
  {
    icon: 'star',
    title: EmailFolder.STARRED,
  },
  {
    icon: 'send',
    title: EmailFolder.SENT,
  },
  {
    icon: 'draft',
    title: EmailFolder.DRAFTS,
  },
  {
    icon: 'envelope',
    title: EmailFolder.ALL_MAILS,
  },
  {
    icon: 'trash-bin',
    title: EmailFolder.TRASH,
  },
];
